import { useMemo } from 'react';

import type { StarsWebExtraWallet } from '@swf/core/models/sports/extraWallets/types';

export const useGetSortedApplicableWallets = (
  applicableWallets: number[],
  allWallets: StarsWebExtraWallet[]
) => {
  const sortApplicableWallets = useMemo(() => {
    const matchingExtraWallets = applicableWallets.reduce<StarsWebExtraWallet[]>(
      (acc, applicableWallet) => {
        const wallet = allWallets.find((wallet) => Number(wallet.id) === applicableWallet);

        if (wallet) {
          return [...acc, wallet];
        }

        return acc;
      },
      []
    );

    return matchingExtraWallets.sort((a, b) => {
      // i. Expiration date
      const expiryATime = new Date(a.expiry).getTime();
      const expiryBTime = new Date(b.expiry).getTime();
      if (expiryATime < expiryBTime) return -1;
      if (expiryATime > expiryBTime) return 1;

      // ii. Eligible EventIds
      if (a.eligibleEvents && !b.eligibleEvents) return -1;
      if (!a.eligibleEvents && b.eligibleEvents) return 1;

      // iii. Eligible Sports
      if (a.eligibleSports && !b.eligibleSports) return -1;
      if (!a.eligibleSports && b.eligibleSports) return 1;

      // iv. Amount
      return b.amount - a.amount;
    });
  }, [allWallets, applicableWallets]);
  return sortApplicableWallets;
};
